'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var $ = require("jquery");
var Menu = /** @class */ (function () {
    function Menu() {
        $('.trigOpenMenu').on('click', function () {
            $('.bulletMenu').fadeIn();
            $('body').addClass('no-scroll');
        });
        $('.trigCloseMenu').on('click', function () {
            $('.bulletMenu').fadeOut();
            $('body').removeClass('no-scroll');
        });
    }
    return Menu;
}());
exports.Menu = Menu;
exports.default = Menu;
